export default __webpack_public_path__ + "static/media/cp_geo_sm.ac0919ef.svg";